import { Injectable, signal, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from './storage.service';

type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly storage    = inject(StorageService);
  private readonly platformId = inject(PLATFORM_ID);

  private readonly _theme = signal<Theme>(this.getInitialTheme());

  readonly theme      = this._theme.asReadonly();
  readonly isDarkMode = () => this._theme() === 'dark';

  private getInitialTheme(): Theme {
    if (!isPlatformBrowser(this.platformId)) return 'light';
    return this.storage.getTheme();
  }

  init(): void {
    this.applyTheme(this._theme());
  }

  toggle(): void {
    const next: Theme = this._theme() === 'dark' ? 'light' : 'dark';
    this._theme.set(next);
    this.storage.setTheme(next);
    this.applyTheme(next);
  }

  private applyTheme(theme: Theme): void {
    document.documentElement.setAttribute('data-theme', theme);
  }
}
